import {
  PageHeader,
  PageHeaderPeriodPicker
} from 'components/shared'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { ACTION_HISTORY_TABLE_STORE, FilterPeriods, periodOptions } from 'store'
import styles from './ActionHistoryPage.module.scss'
import { ActionHistoryPageProps } from './ActionHistoryPage.types'
import { ActionHistoryTable } from 'components'
import { IconActionHistory } from 'assets'
import { User } from 'utilities'

const ActionHistoryPageComponent = (props: ActionHistoryPageProps) => {
  const {
    [ACTION_HISTORY_TABLE_STORE]: {
      filterPeriod,
      onFilterPeriodChange,
      searchProps,
      onSearchPropsChange,
      setFilterPeriod
    }
  } = props

  useEffect(() => {
    setFilterPeriod(FilterPeriods.TODAY)
  }, [setFilterPeriod])

  return (
    <div className={styles.pageContainer} style={{ overflow: 'hidden' }}>
      <PageHeader
        navSegments={[{
          label: 'My action history',
          icon: IconActionHistory,
          iconProps: { width: 40 }
        }]}
        buttonsContainerChildren={
          <PageHeaderPeriodPicker
            selectProps={{
              options: periodOptions,
              value: filterPeriod,
              onChange: onFilterPeriodChange
            }}
            periodPickerProps={{
              period: searchProps.period,
              setPeriod: period => {
                onFilterPeriodChange(FilterPeriods.CUSTOM)
                onSearchPropsChange({ period })
              }
            }}
          />
        }
      />
      <ActionHistoryTable
        userId={User.getId()}
      />
    </div>
  )
}

const ActionHistoryPage = inject(
  ACTION_HISTORY_TABLE_STORE
)(observer(ActionHistoryPageComponent))
export { ActionHistoryPage }
